/* Baitishk - Back to School 2026 promo (v4)
   Extra 5% when cart qty >= 2 from collection back-to-school-2026.
   PDP strip under price + cart drawer nudge. ASCII only (Arabic via \u). */
(function () {
  'use strict';

  var HANDLE = 'back-to-school-2026';
  var MIN_QTY = 2;
  var CACHE_KEY = 'btsIds_v1';
  var CACHE_TTL = 30 * 60 * 1000;

  var AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;

  var T = AR ? {
    label: '\u0639\u0631\u0636 \u0627\u0644\u0639\u0648\u062f\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062f\u0627\u0631\u0633',
    rule: '\u0627\u0634\u062a\u0631\u0650 \u0642\u0637\u0639\u062a\u064a\u0646 \u0623\u0648 \u0623\u0643\u062b\u0631 \u0648\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u062e\u0635\u0645 \u0625\u0636\u0627\u0641\u064a 5%',
    stNone: '\u0623\u0636\u0641 \u0642\u0637\u0639\u062a\u064a\u0646 \u0644\u062a\u0641\u0639\u064a\u0644 \u0627\u0644\u062e\u0635\u0645',
    stAdd: '\u0623\u0636\u0641 \u0642\u0637\u0639\u0629 \u0648\u0627\u062d\u062f\u0629 \u0623\u062e\u0631\u0649 \u0644\u062a\u0641\u0639\u064a\u0644 \u0627\u0644\u062e\u0635\u0645',
    stOk: '\u062a\u0645 \u062a\u0641\u0639\u064a\u0644 \u0627\u0644\u062e\u0635\u0645 \u0627\u0644\u0625\u0636\u0627\u0641\u064a',
    cartDone: '\u0631\u0627\u0626\u0639! \u062d\u0635\u0644\u062a \u0639\u0644\u0649 \u062e\u0635\u0645 \u0625\u0636\u0627\u0641\u064a 5%'
  } : {
    label: 'Back to School offer',
    rule: 'Buy 2 or more, get an extra 5% off',
    stNone: 'Add 2 items to unlock',
    stAdd: 'Add 1 more to unlock',
    stOk: 'Extra discount unlocked',
    cartDone: 'Nice! Extra 5% off unlocked'
  };

  var ICON_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 12 22l-9-9V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m8.5 12.2 2.4 2.4 4.6-4.9"/></svg>';

  var ids = null;
  var cartQty = 0;

  /* ---------- data ---------- */

  function loadIds() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var c = JSON.parse(raw);
        if (c && c.t && Date.now() - c.t < CACHE_TTL && c.v) {
          ids = c.v;
          return Promise.resolve(ids);
        }
      }
    } catch (e) {}

    return fetch('/collections/' + HANDLE + '/products.json?limit=250', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.products) { ids = []; return ids; }
        ids = d.products.map(function (p) { return String(p.id); });
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), v: ids }));
        } catch (e) {}
        return ids;
      })
      .catch(function () { ids = []; return ids; });
  }

  function isEligible(id) {
    return !!ids && ids.indexOf(String(id)) !== -1;
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        cartQty = 0;
        if (c && c.items) {
          c.items.forEach(function (it) {
            if (isEligible(it.product_id)) cartQty += it.quantity;
          });
        }
        return cartQty;
      })
      .catch(function () { return cartQty; });
  }

  /* ---------- pdp ---------- */

  function currentProductId() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    var txt = (el.textContent || '').trim();
    var n = txt.replace(/[^0-9]/g, '');
    return n || null;
  }

  function findPriceAnchor() {
    var info = document.querySelector('[id^="ProductInfo-"]');
    if (!info) return null;
    var price =
      info.querySelector('.price__container') ||
      info.querySelector('.product__price') ||
      info.querySelector('.price');
    if (!price) return null;

    var host = info.querySelector('.sticky-md') || info;
    var node = price;
    while (node && node.parentNode && node.parentNode !== host) node = node.parentNode;
    return node && node.parentNode === host ? node : price;
  }

  function buildStrip() {
    var d = document.createElement('div');
    d.className = 'bts-strip';
    d.setAttribute('data-bts-strip', '');
    d.innerHTML =
      '<span class="bts-strip__icon">' + ICON_TAG + '</span>' +
      '<span class="bts-strip__body">' +
      '<span class="bts-strip__label"></span>' +
      '<span class="bts-strip__msg"></span>' +
      '<span class="bts-strip__status">' +
      '<span class="bts-strip__count"></span>' +
      '<span class="bts-strip__hint"></span>' +
      '</span>' +
      '</span>';
    d.querySelector('.bts-strip__label').textContent = T.label;
    d.querySelector('.bts-strip__msg').textContent = T.rule;
    return d;
  }

  function paintStrip(strip, firstPaint) {
    /* Count only what is actually in the cart. The PDP quantity picker is a
       forecast, not cart state - adding it here double-counted once the item
       was added (cart 1 + picker 1 = 2) and falsely showed the discount as
       unlocked while checkout applied nothing. */
    var inCart = cartQty;
    var unlocked = inCart >= MIN_QTY;
    var count = strip.querySelector('.bts-strip__count');
    var hint = strip.querySelector('.bts-strip__hint');
    var icon = strip.querySelector('.bts-strip__icon');

    var shown = inCart > MIN_QTY ? MIN_QTY : inCart;
    var nextCount = shown + ' / ' + MIN_QTY;
    var nextHint = unlocked ? T.stOk : (inCart === 0 ? T.stNone : T.stAdd);

    if (hint.textContent !== nextHint && !firstPaint) {
      hint.classList.remove('is-swapping');
      void hint.offsetWidth;
      hint.classList.add('is-swapping');
    }
    count.textContent = nextCount;
    hint.textContent = nextHint;
    icon.innerHTML = unlocked ? ICON_OK : ICON_TAG;
    strip.classList.toggle('is-unlocked', unlocked);
  }

  function mountPdp() {
    var pid = currentProductId();
    if (!pid || !isEligible(pid)) return;
    if (document.querySelector('[data-bts-strip]')) return;

    var anchor = findPriceAnchor();
    if (!anchor || !anchor.parentNode) return;

    var strip = buildStrip();
    anchor.parentNode.insertBefore(strip, anchor.nextSibling);
    paintStrip(strip, true);

    requestAnimationFrame(function () {
      strip.classList.add('is-visible');
      strip.classList.add('is-pulse');
    });

    var info = document.querySelector('[id^="ProductInfo-"]') || document;
    ['change', 'input', 'click'].forEach(function (ev) {
      info.addEventListener(ev, function () {
        setTimeout(function () { paintStrip(strip, false); }, 40);
      }, true);
    });
  }

  /* ---------- cart ---------- */

  function buildNudge() {
    var d = document.createElement('div');
    d.className = 'bts-cart-nudge';
    d.setAttribute('data-bts-nudge', '');
    d.innerHTML =
      '<span class="bts-cart-nudge__icon">' + ICON_TAG + '</span>' +
      '<span class="bts-cart-nudge__count"></span>' +
      '<span class="bts-cart-nudge__msg"></span>';
    return d;
  }

  function cartHosts() {
    var out = [];
    var sels = [
      'cart-drawer .drawer__footer',
      'cart-drawer .cart-drawer__footer',
      '#CartDrawer .drawer__footer',
      '.cart-drawer__inner .drawer__footer',
      '.drawer__footer',
      '.cart__footer',
      '#main-cart-footer .cart__footer'
    ];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (n) {
        if (out.indexOf(n) === -1) out.push(n);
      });
    });
    return out;
  }

  function paintNudge(n) {
    var unlocked = cartQty >= MIN_QTY;
    var shown = cartQty > MIN_QTY ? MIN_QTY : cartQty;
    n.querySelector('.bts-cart-nudge__count').textContent = shown + ' / ' + MIN_QTY;
    n.querySelector('.bts-cart-nudge__msg').textContent = unlocked ? T.cartDone : T.rule;
    n.querySelector('.bts-cart-nudge__icon').innerHTML = unlocked ? ICON_OK : ICON_TAG;
    n.classList.toggle('is-unlocked', unlocked);
  }

  function mountCart() {
    var hosts = cartHosts();
    if (!hosts.length) return;

    if (cartQty < 1) {
      document.querySelectorAll('[data-bts-nudge]').forEach(function (n) { n.remove(); });
      return;
    }

    hosts.forEach(function (host) {
      var existing = host.querySelector('[data-bts-nudge]');
      if (existing) { paintNudge(existing); return; }
      var n = buildNudge();
      paintNudge(n);
      host.insertBefore(n, host.firstChild);
      requestAnimationFrame(function () { n.classList.add('is-visible'); });
    });
  }

  /* ---------- refresh plumbing ---------- */

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      loadCart().then(function () {
        mountCart();
        var strip = document.querySelector('[data-bts-strip]');
        if (strip) paintStrip(strip, false);
      });
    }, 160);
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var s = typeof url === 'string' ? url : (url && url.url) || '';
    var p = _fetch.apply(this, arguments);
    if (s.indexOf('/cart/') !== -1) p.then(function () { refresh(); }).catch(function () {});
    return p;
  };

  ['cart:updated', 'cart:refresh', 'cart:change', 'on:cart:change'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
    window.addEventListener(ev, refresh);
  });

  /* Survives baitishk-patches.js node replacement: observe body, re-mount if
     our nodes were detached along with the section wrapper. */
  var obsPending = null;
  var obs = new MutationObserver(function () {
    clearTimeout(obsPending);
    obsPending = setTimeout(function () {
      if (!ids) return;
      if (!document.querySelector('[data-bts-strip]')) mountPdp();
      if (cartQty >= 1 && cartHosts().length && !document.querySelector('[data-bts-nudge]')) {
        mountCart();
      }
    }, 120);
  });

  function boot() {
    loadIds().then(function () {
      return loadCart();
    }).then(function () {
      mountPdp();
      mountCart();
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
